
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3293|4542|6674|8614|9840)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
